import {
  Component, ViewEncapsulation, ChangeDetectionStrategy, Input
} from '@angular/core';

import { Price } from '@app/entities/price';
import { HotelSearchedRoomRate } from '@hotels/hotel-results/entities/hotel-searched';

@Component({
  selector: 'app-hotel-rate-discount',
  templateUrl: './hotel-rate-discount.component.html',
  styleUrls: ['./hotel-rate-discount.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HotelRateDiscountComponent {

  @Input() translateKey: string;
  @Input() translateProp: string;
  @Input() room: HotelSearchedRoomRate;
  @Input() htmlFormatByCurrency: boolean;
  @Input() isPrime: boolean;
  @Input() source: string;

  constructor() { }

  get price(): Price {
    return this.room?.Price;
  }

}
